export default {
    namespaced: true,
    state: {
        objs: [],
        obj: {}
    },
    mutations: {
        setObjs(state, data) {
            state.objs = data
        },
        setObj(state, data) {
            state.obj = data
        }
    },
    actions: {
        async getObjs({ commit, rootState }, { apidomain = 'outlet-closings', parameter = '' } = {}) {
            const url = rootState.config.apiHost + apidomain + parameter
            try {
                const response = await this._vm.$axios.get(url, {
                    headers: {
                        'Authorization': 'Bearer ' + rootState.token,
                        'Content-Type': 'application/json'
                    }
                })
                if (response.data.status === 'success') {
                    commit('setObjs', response.data.data)
                }
                return response
            } catch (error) {
                console.error('Error fetching outlet closings:', error)
                throw error
            }
        },
        async getObj({ commit, rootState }, id) {
            const url = rootState.config.apiHost + 'outlet-closings/' + id
            try {
                const response = await this._vm.$axios.get(url, {
                    headers: {
                        'Authorization': 'Bearer ' + rootState.token,
                        'Content-Type': 'application/json'
                    }
                })
                if (response.data.status === 'success') {
                    commit('setObj', response.data.data)
                    return response.data.data
                }
                return response
            } catch (error) {
                console.error('Error fetching outlet closing:', error)
                throw error
            }
        },
        async postObj({ rootState }, payload) {
            const url = rootState.config.apiHost + 'outlet-closings'
            try {
                const response = await this._vm.$axios.post(url, JSON.stringify(payload), {
                    headers: {
                        'Authorization': 'Bearer ' + rootState.token,
                        'Content-Type': 'application/json'
                    }
                })
                return response
            } catch (error) {
                console.error('Error creating outlet closing:', error)
                throw error
            }
        },
        async putObj({ rootState }, { id, payload }) {
            const url = rootState.config.apiHost + 'outlet-closings/' + id
            try {
                const response = await this._vm.$axios.put(url, JSON.stringify(payload), {
                    headers: {
                        'Authorization': 'Bearer ' + rootState.token,
                        'Content-Type': 'application/json'
                    }
                })
                return response
            } catch (error) {
                console.error('Error updating outlet closing:', error)
                throw error
            }
        },
        async deleteObj({ rootState }, id) {
            const url = rootState.config.apiHost + 'outlet-closings/' + id
            try {
                const response = await this._vm.$axios.delete(url, {
                    headers: {
                        'Authorization': 'Bearer ' + rootState.token,
                        'Content-Type': 'application/json'
                    }
                })
                return response
            } catch (error) {
                console.error('Error deleting outlet closing:', error)
                throw error
            }
        }
    }
}
